import continents from './continents/fr'
import countries from './countries/fr'

export default {
  global: {
    dashboard: 'Accueil',
    coins: 'Pièces',
    coin: 'Pièce',
    banknotes: 'Billets',
    banknote: 'Billet',
    books: 'Classeurs',
    book: 'Classeur',
    logout: 'Se déconnecter',
    continent: 'Continent',
    country: 'Pays',
    quantity: 'Quantité',
    year: 'Année',
    image: 'Image',
    images: 'Images',
    save: 'Enregistrer',
    update: 'Modifier',
    close: 'Fermer',
    required: 'Champs obligatoires',
    search: 'Rechercher',
    back: 'Retour',
    edit: 'Modifier',
    delete: 'Supprimer',
    cancel: 'Annuler',
    add: 'Ajouter',
    yes: 'Oui',
    no: 'Non',
    description: 'Description'
  },
  login: {
    title: 'Bienvenue sur Numisma!',
    subtitle: 'Merci de vous connecter afin d\'accéder à votre trésor',
    credentials: {
      title: 'Connectez-vous avec vos identifiants',
      signin: 'Se connecter'
    },
    forgotten_password: 'Mot de passe oublié ?',
    new_account: 'Nouveau compte',
    email: 'Email',
    password: 'Mot de passe'
  },
  register: {
    title: 'Bienvenue sur Numisma!',
    subtitle: 'Merci de vous connecter afin d\'accéder à votre trésor',
    credentials: {
      title: 'Connectez-vous avec vos identifiants',
      signin: 'Se connecter'
    },
    displayName: 'Identifiant',
    email: 'Email',
    password: 'Mot de passe',
    choose_image: 'Choisir une photo',
    create_account: 'Créer le compte',
    back: 'Retour',
    text: 'Merci de remplir tous les champs du formulaire'
  },
  dashboard: {
    welcome: 'Bienvenue !',
    title: 'Accueil',
    map: 'Carte du monde'
  },
  coins: {
    list: 'Liste des pièces',
    add: 'Ajouter une pièce dans {country}',
    select_continent: 'Sélectionnez un continent',
    select_country: 'Sélectionnez un pays',
    none: 'Vide',
    delete: 'Êtes-vous sûr de vouloir supprimer cette pièce ?',
    edit: 'Modification',
    info: 'Informations',
    new: 'Nouvelle pièce'
  },
  banknotes: {
    list: 'Liste des billets',
    add: 'Ajouter un billet dans {country}',
    select_continent: 'Sélectionnez un continent',
    select_country: 'Sélectionnez un pays',
    none: 'Vide',
    delete: 'Êtes-vous sûr de vouloir supprimer ce billet ?',
    edit: 'Modification',
    info: 'Informations',
    new: 'Nouveau billet'
  },
  books: {
    list: 'Liste des classeurs',
    none: 'Vide',
    delete: 'Êtes-vous sûr de vouloir supprimer ce classeur ?',
    delete2: 'Attention, tout le contenu du classeur (pièces et billets) seront supprimés',
    edit: 'Modification',
    info: 'Informations',
    new: 'Nouveau classeur',
    coins: 'aucune pièce | 1 pièce | {count} pièces',
    banknotes: 'aucun billet | 1 billet | {count} billets'
  },
  user: {
    profile: 'Mon profil',
    info: 'Informations',
    displayName: 'Identifiant',
    email: 'Email',
    password: 'Mot de passe',
    photo: 'Photo de profil',
    firstname: 'Prénom',
    lastname: 'Nom'
  },
  continents,
  countries
}



// WEBPACK FOOTER //
// ./src/lang/fr.js